module.exports = __webpack_public_path__ + "static/media/PIR.a5d1e54d.svg";